import { render, staticRenderFns } from "./referral-list.vue?vue&type=template&id=e4029738&scoped=true&"
import script from "./referral-list.vue?vue&type=script&lang=js&"
export * from "./referral-list.vue?vue&type=script&lang=js&"
import style0 from "./referral-list.vue?vue&type=style&index=0&id=e4029738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4029738",
  null
  
)

export default component.exports